import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { NoteRefType, NoteType } from "types/note";

export const noteApi = {
  findAll: (params: {
    page: number;
    limit: number;
    refType: NoteRefType;
    refId: number;
    type?: NoteType;
  }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/note",
      params,
    }),
  create: (data: { note: { content: string; refType: NoteRefType; refId: number } }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/note",
      data,
      method: "post",
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/note/${id}`,
      method: "delete",
    }),
};
